import { create } from 'zustand';

interface RiskLevelState {
  level: 1 | 2 | 3 | 4;
  setLevel: (level: 1 | 2 | 3 | 4) => void;
}

export const useRiskLevelStore = create<RiskLevelState>((set) => ({
  level: 1, // Default to Level 1 (highest risk)
  setLevel: (level) => set({ level }),
}));